import type { FC } from 'react';
import classes from './Step.module.scss';

interface StepProps {
    number: number;
    label: string;
    isActive?: boolean;
}

const Step: FC<StepProps> = ({ number, label, isActive = false }) => (
    <div className={`${classes.wrapper } ${isActive ? classes.active : ''}`}>
        <div className={classes.number}>
            <span>{ number }</span>
        </div>
        <div className={classes.label}>
            <span>{ label }</span>
        </div>
    </div>
);

export default Step;
